import { VERSION } from 'config/env';
import { v4 as uuid } from 'uuid';

const SESSION_ID = uuid();

export const createTrackingHeaders = () => ({
  'x-self-service-version': VERSION,
  'x-session-id': SESSION_ID,
  'x-correlation-id': uuid(),
});
